import React, { useContext, useEffect, useState } from 'react'
import '../Register/Register.css'
import showPass from '../../../Assests/images/eye-open.jpg'
import hidePass from '../../../Assests/images/eye-closed.png'
import Popup from '../../Popup/Popup'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from '../AuthContext/AuthContext'

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [popup, setPopup] = useState({ show: false, message: "", type: "" });
  const { login } = useContext(AuthContext);

  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value
    }));
  };


  useEffect(() => {
    const token = sessionStorage.getItem('token');
    // If logged in and user is navigating to /login directly, redirect to dashboard
    if (token && location.pathname === '/login') {
      navigate('/applicationFormData', { replace: true });
    }
  }, [navigate, location.pathname]);


  const submitLoginForm = () => {
    const payload = loginDetails;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          // Surface the real reason from the server (e.g. "User not found",
          // "Invalid credentials") instead of a generic message.
          throw new Error(data.error || "Login failed. Please try again.");
        }
        return data;
      })

      .then((data) => {
        login(data.user.fullName, data.token);
        console.log("data.user.fullName", data.user.fullName, data.token);
        setPopup({
          show: true,
          message: "Login successfully!",
          type: "success",
        });
          navigate('/applicationFormData', { replace: true });

      })
      .catch((err) => {
        setPopup({
          show: true,
          message: err.message || "Something went wrong. Please try again.",
          type: "error",
        });
      });
  }

  const togglePassword = () => {
    setShowPassword((prev) => !prev);

  };

  console.log("loginDetails", loginDetails)
  return (
    <div className='registrationMain'>
      <div className="registrationSub">
        <h2>Admin Login</h2>
        <div className="registerFrom">

          <div className="formInput">
            <label>
              Email <span className="requiredStar">*</span>
            </label>
            <input
              type="text"
              name="email"
              placeholder='Enter Email'
              value={loginDetails.email}
              onChange={handleChange}
            />
          </div>

          <div className="formInput" style={{ position: "relative" }}>
            <label>
              Password<span className="requiredStar">*</span>
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder='Enter Password'
              value={loginDetails.password}
              onChange={handleChange}
            />
            <button onClick={togglePassword} className='passWordEye'><img
              src={showPassword ? showPass : hidePass}
              alt="Toggle visibility" />
            </button>
          </div>



          <div className="" style={{ textAlign: "center", marginTop: "10px" }}>
            <button className='submitFormBtn' onClick={submitLoginForm}>Login</button>
          </div>
        </div>




      </div>
      {popup.show && (
        <Popup
          message={popup.message}
          type={popup.type}
          onClose={() => setPopup({ show: false, message: "", type: "" })}
        />
      )}
    </div>
  )
}

export default Login